import { render, staticRenderFns } from "./ClientBills.vue?vue&type=template&id=24e06384&"
import script from "./ClientBills.vue?vue&type=script&lang=js&"
export * from "./ClientBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports